import React from 'react';
import clsx from 'clsx';
import styles from './index.scss';

export default function Button(props) {
  const { className, disabled, onClick, text } = props;
  // Render button
  return (
    <div
      className={clsx(
        className,
        'button',
        disabled && 'disabled',
        styles.button,
        disabled && styles.disabled
      )}
      onClick={(event) => !disabled && onClick?.(event)}
    >
      {text}
    </div>
  );
}
